import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import {
    Menu,
    MenuHandler,
    MenuList,
} from "@material-tailwind/react";
import ToggleIcon from '../../admin/toggleCard/ToggleIcon';

import { CurrentUserContext } from '../../../App'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFax, faFile, faFileEdit, faFileLines, faKey, faSignOut, faUnlock, faUserCircle } from '@fortawesome/free-solid-svg-icons';

function MenuInfo() {
    const user = JSON.parse(localStorage.getItem('user'))

    const {
        userRole,
        setUserRole
    } = useContext(CurrentUserContext);

    const navigate = useNavigate()
    const [toggle, setToggle] = useState(false)

    const [widtht, setWidth] = useState(0);

    useEffect(() => {
        setUserRole(user) //ใช้อัพเดท route path ทุกครั้งถ้ามีการ อัพเดท
    }, [])

    useEffect(() => {
        const updateWindowDimensions = () => {
            const newWidth = window.innerWidth;
            setWidth(newWidth);
            // console.log("updating Width");
        };

        window.addEventListener("resize", updateWindowDimensions);

        return () => window.removeEventListener("resize", updateWindowDimensions)
    }, []);

    useEffect(() => {
        if (widtht < 767) {
            setToggle(false)
        }
    }, [widtht])

    return (
        <Menu open={toggle}>
            <MenuHandler onClick={() => { setToggle(!toggle) }}>
                <button className="flex h-[80px] w-full justify-center items-center px-3 bg-[#4F9C9D] hover:drop-shadow-sm">
                    <img className={`lg:w-[30px] lg:h-[30px] rounded-full ${user?.profile_image ? "w-[54px] h-[54px]" : "w-[48px] h-[48px]"}`} src={user?.profile_image ? user?.profile_image : require('../../../asset/icon/iconuser.svg').default} alt="iconuser" />
                    <div className='flex flex-col items-start w-full h-full text-left justify-center'>
                        <div className='flex items-center w-full justify-start'>
                            <p className="text-[#FFFFFF] text-lg font-medium px-3 lg:text-sm">
                                {user?.fname + ' ' + user?.lname}
                            </p>
                            <ToggleIcon 
                                toggleCards 
                                onToggle={() => setToggle(!toggle)} 
                                toggleStatus={toggle} 
                            />
                        </div>
                        <div className='flex items-center w-full justify-start'>
                            <p className="text-[14px] text-[#FFFFFF] px-3 ">ผู้ดูเเลระบบ</p>
                        </div>
                    </div>
                </button>
            </MenuHandler>
            <MenuList className="text-black bg-gray-300 p-0 text-nowrap rounded-b-md shadow-md">
                <button onClick={() => navigate('/manageinfo')} className="flex flex-row gap-2 w-full items-center px-5 py-2 bg-white cursor-pointer">
                    <FontAwesomeIcon icon={faUserCircle}/>
                    <p className="text-base">จัดการข้อมูลส่วนตัว</p>
                </button>
                <button onClick={() => { navigate('/patient/degradgene') }} className="flex flex-row gap-2 w-full items-center px-5 py-2 bg-white cursor-pointer">
                    <FontAwesomeIcon icon={faFileLines}/>
                    <p className="text-base">ผลการตรวจทางห้องปฏิบัติการ</p>
                </button>
                <button onClick={() => { navigate('/patient/permissionAccessData') }} className="flex flex-row gap-2 w-full items-center px-5 py-2 bg-white cursor-pointer">
                    <FontAwesomeIcon icon={faUnlock}/>
                    <p className="text-base">สิทธิ์การเข้าถึงข้อมูล</p>
                </button>
                {/* <button onClick={() => { navigate('/patient/about') }} className="flex flex-row gap-2 w-full items-center px-5 py-2 bg-white cursor-pointer">
                    <FontAwesomeIcon icon={faSignOut}/>
                    <p className="text-base">เกี่ยวกับเรา</p>
                </button> */}
                {/* <button onClick={() => { navigate('/patient/questionnaire') }} className="flex flex-row gap-2 w-full items-center px-5 py-2 bg-white cursor-pointer">
                    <FontAwesomeIcon icon={faSignOut}/>
                    <p className="text-base">แบบสอบถามจากผู้ดูแล</p>
                </button> */}
                <button onClick={() => { navigate('/patient/changePassword') }} className="flex flex-row gap-2 w-full items-center px-5 py-2 bg-white cursor-pointer">
                    <FontAwesomeIcon icon={faKey}/>
                    <p className="text-base">เปลี่ยนรหัสผ่าน</p>
                </button>
                <button onClick={() => {
                    localStorage.clear()
                    navigate('/login')
                }} className="flex flex-row gap-2 w-full items-center px-5 py-2 bg-white cursor-pointer">
                    <FontAwesomeIcon icon={faSignOut}/>
                    <p className="text-base">ออกจากระบบ</p>
                </button>
            </MenuList>
        </Menu>
    )
}
export default MenuInfo;